import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { baseUrl } from "config/config";
import { getApiCall } from "services/apiHelper";


interface InvDetailsState {
    data: InvDetailsResponse;
    loading: boolean;
    error: string | null;
}

interface InvDetailsResponse {
    message: string;
    result: InvDetails[];
}

interface InvDetails {
    invNum: string;
    invName: string;
}

const initialState: InvDetailsState = {
    data: {
        message: "",
        result: []
    },
    loading: false,
    error: null
};

export const getInvData = createAsyncThunk("getInvData", async (_, { rejectWithValue }) => {
    try {
        var url = `${baseUrl}property/GetInv`;
        const response = await getApiCall<any>(url);
        return response;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})` || error.message);
    }
})

const invDataSlice = createSlice({
    name: 'invData',
    initialState,
    reducers: {
        resetState: (state) => {
            return initialState

        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInvData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getInvData.fulfilled, (state, action: PayloadAction<InvDetailsResponse>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getInvData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
    },
});

export const { resetState: resetInvData } = invDataSlice.actions;
export default invDataSlice.reducer;
